import { fetchClasses } from "../../../api/live-classes"
import { mapGameName } from "../../../constants/liveClass"

const state = {
  fullScheduleClasses: [],
  freeClassesOnly: false,
  selectedGames: [],
  lastPage: 1,
  currentPage: 1,
}

const getters = {
  fullScheduleClasses: state => state.fullScheduleClasses,
  freeClassesOnly: state => state.freeClassesOnly,
  // instructors: state => state.instructors,
  // categories: state => state.categories,
  lastPage: state => state.lastPage,
  currentPage: state => state.currentPage,
  selectedGames: state => state.selectedGames,
  // selectedDate: state => state.selectedDate
}

const mutations = {
  setFullScheduleClasses: (state, fullScheduleClasses) =>
    (state.fullScheduleClasses = fullScheduleClasses),
  setFreeClassesOnly: (state, bol) => (state.freeClassesOnly = bol),
  setLastPage: (state, page) => (state.lastPage = page),
  setCurrentPage: (state, page) => (state.currentPage = page),
  setSelectedGames: (state, games) => (state.selectedGames = games),
}

const actions = {
  async fetchClasses ({ commit, state }, { coachId, status, order, page }) {
    if (page) {
      commit("setCurrentPage", page)
    }
    const data = await fetchClasses({
      coachId,
      status,
      order,
      games: state.selectedGames,
      page,
    })

    commit("setLastPage", data.result.last_page)
    const fullScheduleClasses = data.result.data
    for (let scheduleClass of fullScheduleClasses) {
      if (scheduleClass.game) {
        scheduleClass.game.name = mapGameName(scheduleClass.game.name)
      } else {
        scheduleClass.game = { name: mapGameName("") }
      }
    }
    commit("setFullScheduleClasses", fullScheduleClasses)
  },
  toggleFreeClassesOnly ({ commit, state }) {
    commit("setFreeClassesOnly", !state.freeClassesOnly)
  },
  async updateSelectedGames ({ commit, dispatch }, games) {
    await commit("setSelectedGames", games)
    dispatch("fetchClasses", {
      status: "PENDING",
      order: "OLDEST_FIRST",
      page: 1,
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/live-classes/full-schedule.js